<template>
  <div>
    <div
      v-if="variant === 'history'"
      class="group_10 flex-col"
    >
      <div class="image-text_1 flex-row justify-between">
        <div class="section_2 flex-col"></div>
        <span class="text-group_2">{{ config.title }}</span>
      </div>
      <div class="box_3 flex-col"></div>
      <div class="box_4 flex-col"></div>
      <div class="box_5 flex-row">
        <span class="text_23" v-html="config.highlightText"></span>
        <img
          class="thumbnail_8"
          :src="config.highlightIcon"
          referrerpolicy="no-referrer"
        />
      </div>
      <div class="box_6 flex-row justify-between">
        <div class="group_11 flex-col">
          <img
            class="image_5"
            :src="config.gallery.mainImage"
            referrerpolicy="no-referrer"
          />
          <div class="image-wrapper_3 flex-row">
            <img
              class="image_6"
              v-for="(image, index) in config.gallery.items"
              :key="`history-gallery-${index}`"
              :src="image"
              referrerpolicy="no-referrer"
            />
          </div>
        </div>
        <div class="group_12 flex-row">
          <span
            class="paragraph_3"
            v-html="config.sideParagraph"
          ></span>
          <img
            class="thumbnail_9"
            :src="config.sideImage"
            referrerpolicy="no-referrer"
          />
        </div>
      </div>
    </div>

    <div
      v-else-if="variant === 'gallery'"
      class="section_7 flex-col"
    >
      <div class="image-text_1 flex-row justify-between">
        <div class="section_8 flex-col"></div>
        <span class="text-group_2">{{ config.title }}</span>
      </div>
      <div class="group_3 flex-col"></div>
      <img
        class="image_4"
        :src="config.bannerImage"
        referrerpolicy="no-referrer"
      />
      <div class="image-text_2 flex-row">
        <div class="image-text_3 flex-row">
          <span
            class="paragraph_5"
            v-html="config.leftColumn.primaryList"
          ></span>
          <img
            class="thumbnail_8"
            :src="config.leftColumn.middleIcon"
            referrerpolicy="no-referrer"
          />
          <span
            class="paragraph_6"
            v-html="config.leftColumn.secondaryList"
          ></span>
          <div
            class="section_9 flex-col"
            :style="timelineStyle"
          >
            <div
              v-for="(item, index) in config.timelineIcons"
              :key="`timeline-icon-${index}`"
              :class="['timeline-icon-slot', item.wrapperClass]"
            >
              <img
                v-for="(icon, iconIndex) in item.icons"
                :key="`timeline-icon-${index}-${iconIndex}`"
                :class="icon.className"
                :src="icon.src"
                referrerpolicy="no-referrer"
              />
            </div>
          </div>
        </div>
        <img
          class="thumbnail_19"
          :src="config.rightColumnImage"
          referrerpolicy="no-referrer"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecondaryBottom',
  props: {
    variant: {
      type: String,
      required: true
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    timelineStyle() {
      if (this.variant !== 'gallery') {
        return {};
      }
      return this.config.timelineBackground
        ? {
            backgroundImage: `url(${this.config.timelineBackground})`
          }
        : {};
    }
  }
};
</script>

<style scoped>
.timeline-icon-slot {
  display: flex;
}
</style>
